import { __awaiter } from 'tslib';
import { ContextClassBase, ServiceIdentity } from '../service/RuntimeContext.js';

// 给 BytedIM 做 extension method
// TODO: 支持插件加载顺序
class BasePlugin extends ContextClassBase {
    get instance() {
        return this.resolve(ServiceIdentity.CoreInstance);
    }
    ;
    constructor(ctx) {
        super(ctx);
    }
    /**
     * IM init 时调用, 会被 await 可以不实现
    */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    /**
     * 发送 packet 前的钩子 埋在 BaseApiManager.send 里 可以返回一个修改后的 packet, shark 用到了这个钩子用来埋参数
    */
    sendPacket(packet) {
        return __awaiter(this, void 0, void 0, function* () {
            return packet;
        });
    }
    /**
     * 收到 packet 时的钩子, 对应的位置是 BytedIM.receivePacket, 会被 await
     * 处理普通消息的流程走 MessageManager.processors
     * 可以不实现, 默认不特别处理 push 给陌生人之类的 cmd 都不同的消息用
    */
    receivePacket(packet) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    /**
     * 时钟, 每pullInterval触发一次
    */
    ticker() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    /**
     * 包装成给 BytedIM 扩展的方法
    */
    extendFunc(func) {
        return func.bind(this);
    }
    /**
     * dispose 时调用
    */
    dispose() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
}

export { BasePlugin };
//# sourceMappingURL=BasePlugin.js.map
